<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import { authComputed } from "@/state/helpers";
import TimeEffortForm from "@/views/pages/service-forms/timesheet/components/time-effort-form";
import store from "@/state/store";
import VueHtml2pdf from "vue-html2pdf";

export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    if (userType === 2 || userType === 3) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Timesheet",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    FullCalendar,
    Layout,
    PageHeader,
    TimeEffortForm,
    VueHtml2pdf,
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.fetchPayroll();
  },
  data() {
    return {
      title: "Timesheet",
      items: [
        {
          text: "IHUMANE",
        },
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Timesheet",
          active: true,
        },
      ],
      calendarOptions: {
        headerToolbar: {
          left: "title",
          center: "",
          right: "",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        initialDate: null,
        initialEvents: [],
        editable: false,
        droppable: false,
        eventResizableFromStart: false,
        dateClick: this.dateClicked,
        weekends: false,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        showNonCurrentDates: false,
        fixedWeekCount: false,
      },
      currentEvents: [],
      showModal: false,
      eventModal: false,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      event: {
        title: "",
        category: "",
      },
      editevent: {
        editTitle: "",
        editcategory: "",
      },
      dateInfo: null,
      pymYear: "",
      pymMonth: "",
      pymFullDate: "",
      fetching: false,
      populateOption: false,
      entryCount: 0,
      populating: false,
      timeAllocated: false,
      publicHolidays: [],
      groupedPublicHolidays: [],
      exportPublicHolidays: [],
      showModalPH: false,
      phName: "",
      breakdown: [],
      calendarView: false,
      status: null,
      refNo: null,
      employeeLeaves: [],
      salaryMappings: [],
      timesheet: null,
      leaveInfo: null,
      annualLeave: {},
      sickLeave: {},
      annualBF: 0,
      annualAccrued: 0,
      sickBF: 0,
      sickAccrued: 0,
      annualUsed: 0,
      sickUsed: 0,
      log: [],
      totalDurationHrs: 0,
      totalDurationMins: 0,
      location: null,
    };
  },
  methods: {
    async fetchPayroll() {
      let url = `${this.ROUTES.publicHolidays}/holiday`;
      await this.apiGet(url).then((res) => {
        this.publicHolidays = res.data;
      });
      await this.apiGet(this.ROUTES.publicHolidays).then((res) => {
        this.groupedPublicHolidays = res.data;
      });
      url = `${this.ROUTES.leaveApplication}/get-employee-leave/${this.getEmployee.emp_id}`;
      await this.apiGet(url, "Get Employee Leaves Error").then((res) => {
        const { data } = res.data;
        this.employeeLeaves = data.map((leave) => {
          if (leave.leapp_status !== 2 && leave.leapp_status !== 0) {
            return {
              leaveType: leave.LeaveType.leave_name,
              leaveRange: this.getDatesInRange(
                new Date(leave.leapp_start_date),
                new Date(leave.leapp_end_date)
              ),
            };
          } else {
            return {
              leaveType: leave.LeaveType.leave_name,
              leaveRange: [],
            };
          }
        });
      });

      let payrollMY = this.$route.params.payrollMY;
      this.pymFullDate = `${payrollMY}-01`;
      this.pymYear = payrollMY.split("-")[0];
      this.pymMonth = payrollMY.split("-")[1];
      let locationId;
      let empId = this.getEmployee.emp_id;
      //
      url = `${this.ROUTES.salary}/pull-salary-routine/${empId}`;
      await this.apiPost(
        url,
        { pym_month: this.pymMonth, pym_year: this.pymYear },
        "Get Salary Routine Error"
      ).then(async (res) => {
        const { data } = res;
        if (data) {
          locationId = data?.locationId;
          await this.fetchLocation(locationId);
          url = `${this.ROUTES.timeAllocation}/salary-mapping-master/${parseInt(
            this.pymMonth
          )}/${parseInt(this.pymYear)}/${parseInt(locationId)}`;
          await this.apiGet(url, "Get Salary Mapping Master Error").then(
            (res) => {
              const { data } = res;
              if (data) {
                const { smm_id } = data;
                const t7 = this.getEmployee.emp_unique_id;
                const url = `${this.ROUTES.timeAllocation}/salary-mapping-details/${smm_id}/${t7}`;
                this.apiGet(url, "Get Salary Mapping Details Error").then(
                  (res) => {
                    this.salaryMappings = res.data;
                  }
                );
              }
            }
          );
        }
      });

      await this.fetchTimeAllocations();
      this.calendarOptions.initialDate = this.pymFullDate;
      this.calendarView = true;
    },
    fetchTimeAllocations() {
      // Here, I tried to get the time allocation for the payroll month and year to see if
      // it's been filled first.
      // const employeeID = this.getEmployee.emp_id;
      const { refNo } = this.$route.params;
      let url = `${this.ROUTES.timeAllocation}/view-time-allocation/${refNo}`;
      this.apiGet(url, "Get Time Allocation Error").then(async (res) => {
        this.breakdown = res.data;
        //console.log(this.breakdown[0])
        let taMonth = this.breakdown[0].ta_month;
        let taEmpId = this.breakdown[0].ta_emp_id;
        const year = this.breakdown[0].ta_year; //new Date().getFullYear();
        const calendarYear =
          taMonth <= 9 ? `FY${year}` : `FY${parseInt(year) + 1}`;
        await this.fetchLeaveInformationDetails(calendarYear, taMonth, taEmpId);
        if (this.breakdown.length) {
          this.status = this.breakdown[0].ta_status;
        }
        this.breakdown.every((tab) => {
          if (tab.ta_status) {
            // stop users from editing their timesheet entries if it has been
            // approved or rejected
            this.calendarOptions.selectable = false;
            this.calendarOptions.dateClick = null;
            return false;
          }
          return true;
        });
        this.fetchTimesheetData();
      });
      // url = `${this.ROUTES.timeAllocation}/get-time-allocation/${employeeID}/${this.pymFullDate}`;
      // this.apiGet(url, "Get Time Allocation Error").then((res) => {
      //   const { timeAllocationBreakDown } = res.data;
      //   this.breakdown = timeAllocationBreakDown;
      // });
    },
    async fetchLeaveInformationDetails(year, month, empId) {
      const url = `${this.ROUTES.leaveAccrual}/leave/annual-sick/${year}/${empId}`;
      this.apiGet(url, "Get Leave Info Error").then((res) => {
        this.leaveInfo = res.data;
        this.leaveInfo.empAccrual.map((leaf) => {
          switch (parseInt(leaf.lea_leave_type)) {
            case 1:
              if (parseInt(leaf.lea_month) < parseInt(month)) {
                this.annualBF += parseFloat(leaf.lea_rate);
              }
              if (
                parseInt(leaf.lea_month) === parseInt(month) &&
                parseFloat(leaf.lea_rate) > 0
              ) {
                this.annualAccrued += parseFloat(leaf.lea_rate);
              }
              if (
                parseInt(leaf.lea_month) === parseInt(month) &&
                parseFloat(leaf.lea_rate) < 0
              ) {
                this.annualUsed += parseFloat(leaf.lea_rate);
              }
              break;
            case 2:
              if (parseInt(leaf.lea_month) < parseInt(month)) {
                this.sickBF += parseFloat(leaf.lea_rate);
              }
              if (
                parseInt(leaf.lea_month) === parseInt(month) &&
                parseFloat(leaf.lea_rate) > 0
              ) {
                this.sickAccrued += parseFloat(leaf.lea_rate);
              }
              if (
                parseInt(leaf.lea_month) === parseInt(month) &&
                parseFloat(leaf.lea_rate) < 0
              ) {
                this.sickUsed += parseFloat(leaf.lea_rate);
              }
              break;
          }
        });
      });
    },
    async dateClicked(info) {
      if (info) {
        this.newEventData = info;
        this.dateInfo = info;
        let isPublicHoliday = false;
        let date = this.dateInfo.dateStr.split("-");
        await this.publicHolidays.every((publicHoliday) => {
          if (
            publicHoliday.ph_year === date[0] &&
            parseInt(publicHoliday.ph_month) === parseInt(date[1]) &&
            parseInt(publicHoliday.ph_day) === parseInt(date[2])
          ) {
            this.phName = publicHoliday.ph_name;
            isPublicHoliday = true;
            return false;
          }
          return true;
        });
        if (!isPublicHoliday) {
          this.showModal = true;
        } else {
          this.showModalPH = true;
        }
      }
    },
    fetchTimesheetData() {
      // Get the timesheet data for an employee for each day of the payroll month.
      const employeeID = this.getEmployee.emp_id;
      const { refNo } = this.$route.params;
      let payrollMY = this.$route.params.payrollMY;
      this.pymYear = payrollMY.split("-")[0];
      this.pymMonth = payrollMY.split("-")[1];
      let url = `${this.ROUTES.timesheet}/time-sheet/${this.pymMonth}/${this.pymYear}/${employeeID}/${refNo}`;
      this.apiGet(url, "Get Timesheet Error").then(async (res) => {
        console.log({ res });
        const { timesheet, log } = res.data;
        let totalHrs = 0;
        let totalMins = 0;
        timesheet.forEach((time) => {
          if (time.ts_is_present === 1) {
            let timeSplit = time.ts_duration.toString().split(".");
            totalHrs += parseFloat(timeSplit[0]);
            totalMins += parseFloat(timeSplit[1]) || 0;
          }
        });
        totalHrs += parseInt(totalMins / 60);
        this.totalDurationHrs = totalHrs;
        this.totalDurationMins = totalMins % 60;

        this.log = log;
        console.log({ timesheet });
        this.processExportTimesheet(timesheet);
        if (timesheet.length) {
          let calendarApi = this.$refs.fullCalendar.getApi();
          let entryObj = {};
          this.publicHolidays.forEach((publicHoliday) => {
            let month, day;
            publicHoliday.ph_month.length === 1
              ? (month = `0${publicHoliday.ph_month}`)
              : (month = publicHoliday.ph_month);
            publicHoliday.ph_day.length === 1
              ? (day = `0${publicHoliday.ph_day}`)
              : (day = publicHoliday.ph_day);
            // publicHoliday.ph_to_month.toString().length === 1
            //   ? (endMonth = `0${publicHoliday.ph_to_month}`)
            //   : (endMonth = publicHoliday.ph_to_month);
            // publicHoliday.ph_to_day.toString().length === 1
            //   ? (endDay = `0${publicHoliday.ph_to_day}`)
            //   : (endDay = publicHoliday.ph_to_day);
            let startDate = `${publicHoliday.ph_year}-${month}-${day}`;
            // let endDate = `${publicHoliday.ph_year}-${endMonth}-${endDay + 1}`;
            entryObj = {
              id: this.entryCount++,
              start: startDate,
              end: startDate,
              display: "block",
              backgroundColor: "red",
              title: `${publicHoliday.ph_name} Public Holiday`,
            };
            calendarApi.addEvent(entryObj);
          });
          await timesheet.forEach((entry) => {
            let month, day, currDate, phDay;
            entry.ts_month.length === 1
              ? (month = `0${entry.ts_month}`)
              : (month = entry.ts_month);
            entry.ts_day.length === 1
              ? (day = `0${entry.ts_day}`)
              : (day = entry.ts_day);
            const date = `${entry.ts_year}-${month}-${day}`;
            entryObj = {
              id: this.entryCount++,
              start: date,
              end: date,
              display: "background",
            };
            switch (entry.ts_is_present) {
              case 0: // employee absent
                entryObj.title = `ABSENT`;
                entryObj.display = "block";
                calendarApi.addEvent(entryObj);
                break;
              case 4: // employee absent
                currDate = new Date(date);
                currDate = new Date(date);
                phDay = this.publicHolidays.find((publicHoliday) => {
                  let month, day;
                  publicHoliday.ph_month.length === 1
                    ? (month = `0${publicHoliday.ph_month}`)
                    : (month = publicHoliday.ph_month);
                  publicHoliday.ph_day.length === 1
                    ? (day = `0${publicHoliday.ph_day}`)
                    : (day = publicHoliday.ph_day);
                  let startDate = `${publicHoliday.ph_year}-${month}-${day}`;
                  return new Date(startDate).getTime() === currDate.getTime();
                });
                if (!phDay) {
                  this.employeeLeaves.forEach((leave) => {
                    const found = leave.leaveRange.find((leaveDate) => {
                      return leaveDate.getTime() === currDate.getTime();
                    });
                    if (found) {
                      entryObj.title = `${leave.leaveType.toUpperCase()}`;
                      entryObj.display = "block";
                      calendarApi.addEvent(entryObj);
                    }
                  });
                }
                break;
              case 1: // employee present
                entryObj.title = `${this.tConvert(
                  entry.ts_start
                )} - ${this.tConvert(entry.ts_end)} for ${
                  entry.ts_duration
                } hrs`;
                calendarApi.addEvent(entryObj);
                break;
              default:
                // do nothing on public holidays and weekends
                break;
            }
          });
        }
      });
      // url = `${this.ROUTES.timesheet}/get-time-sheet-month/${employeeID}/${this.pymFullDate}`;
      // this.apiGet(url, "Get Timesheet Error").then(async (res) => {
      //   const { data } = res;
      // });
      this.fetching = false;
    },
    processExportTimesheet(timesheet) {
      this.timesheet = timesheet;
      this.employeeLeaves.forEach((leave) => {
        if (leave) {
          const { leaveType } = leave;
          leave.leaveRange.forEach((leaveDate) => {
            let payrollMY = this.$route.params.payrollMY;
            let month = payrollMY.split("-")[1];
            if (leaveDate.getMonth() + 1 === parseInt(month)) {
              this.timesheet.forEach((timesheet, index) => {
                if (parseInt(timesheet.ts_day) === leaveDate.getDate()) {
                  this.timesheet[index] = { ...timesheet, leaveType };
                }
              });
            }
          });
        }
      });

      this.timesheet = this.timesheet.map((timesheet) => {
        if (timesheet.ts_duration === 0) {
          //
          const weekend = new Date();
          weekend.setFullYear(timesheet.ts_year);
          weekend.setMonth(parseInt(timesheet.ts_month) - 1);
          weekend.setDate(timesheet.ts_day);
          if (weekend.getDay() === 6 || weekend.getDay() === 0)
            timesheet.ts_is_present = 3;
        }
        let publicHoliday = this.publicHolidays.find((holiday) => {
          return (
            holiday.ph_day === timesheet.ts_day &&
            holiday.ph_month === timesheet.ts_month &&
            holiday.ph_year === timesheet.ts_year
          );
        });
        if (publicHoliday) {
          timesheet.ts_is_present = 2;
          timesheet.holiday = publicHoliday.ph_name;
        }

        return {
          ...timesheet,
        };
      });
    },
    fillTSE(dateInfo) {
      this.$router.push({
        name: "timesheet-entry",
        params: { date: dateInfo.dateStr },
      });
    },
    viewTimesheet() {
      // const payrollMY = `${this.pymYear}-${this.pymMonth}`;
      const { payrollMY } = this.$route.params;
      this.$router.push({
        name: "view-timesheet",
        params: { payrollMY },
      });
    },
    tConvert(time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    },
    getDatesInRange(startDate, endDate) {
      const date = new Date(startDate.getTime());

      const dates = [];

      while (date <= endDate) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }

      return dates;
    },
    exportFile() {
      this.$refs.html2Pdf.generatePdf();
    },
    async fetchLocation(locationId) {
      const url = `${this.ROUTES.location}/${locationId}`;
      await this.apiGet(url, "Get Location Error").then((res) => {
        const { data } = res;
        if (data) {
          this.location = `${data.location_name} (${data.l_t6_code})`;
        }
      });
    },
  },
};
</script>
<style>
/*.fc-event-title {*/
/*  color: blue;*/
/*}*/
.fc .fc-bg-event .fc-event-title {
  font-size: 1.5em;
  color: black;
  padding-top: 2em;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-end mb-3">
      <b-button class="btn btn-danger mr-3" @click="exportFile">
        <i class="fa fa-file-pdf mr-2"></i> Export
      </b-button>
      <b-button
        class="btn btn-success"
        @click="$router.push({ name: 'timesheets' })"
      >
        <i class="mdi mdi-plus mr-2"></i>
        View Timesheets
      </b-button>
    </div>
    <div class="alert alert-success" v-if="this.status === 1">
      This timesheet has been approved and cannot be modified further
    </div>
    <div class="alert alert-danger" v-else-if="this.status === 2">
      This timesheet has been declined and cannot be modified further
    </div>
    <scale-loader class="scale-loader" v-if="this.apiBusy" />
    <div v-else>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="app-calendar">
                <FullCalendar
                  v-if="calendarView"
                  ref="fullCalendar"
                  :options="calendarOptions"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-4">
          <div class="card mb-3">
            <div class="card-body">
              <div class="p-3 bg-light mb-4">
                <h5 class="font-size-14 mb-0">
                  International Rescue Committee - Overseas Staff
                </h5>
              </div>
              <div class="d-flex justify-content-between">
                <p>Payroll Reporting Period</p>
                <p class="font-weight-bolder">
                  <span
                    >{{ new Date(pymFullDate).getMonth() | getMonth }}
                    {{ new Date(pymFullDate).getFullYear() }}</span
                  >
                </p>
              </div>
              <div class="d-flex justify-content-between">
                <p>Name</p>
                <p>
                  {{ getUser.user_name }}
                </p>
              </div>
              <div class="d-flex justify-content-between">
                <p>T7 Code</p>
                <p>{{ getEmployee.emp_unique_id }}</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>Location (T6)</p>
                <p>{{ location }}</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>Site Code (T3)</p>
                <p>{{ getEmployee.sector.d_t3_code }}</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>Nationality</p>
                <p>Non-US</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              <div class="p-3 bg-light mb-4">
                <h5 class="font-size-14 mb-0">Time Allocation</h5>
              </div>
              <div v-if="status">
                <b-row>
                  <b-col lg="6">
                    <p v-for="(charge, index) in breakdown" :key="index">
                      <span class="mr-4">
                        Grant Code: {{ charge.ta_tcode }}
                      </span>
                      <span>Percentage Charge: {{ charge.ta_charge }}%</span>
                    </p>
                  </b-col>
                  <b-col lg="6">
                    <p v-for="(charge, index) in breakdown" :key="index">
                      <span class="mr-4">
                        Match Code: {{ charge.ta_t0_code }}
                      </span>
                      <span>
                        Percentage Charge: {{ parseInt(charge.ta_t0_percent) }}%
                      </span>
                    </p>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <TimeEffortForm
                  :breakdown="breakdown"
                  :pmy-month="pymMonth"
                  :pmy-year="pymYear"
                  :ts-ref-no="refNo"
                  :salary-mappings="salaryMappings"
                  @added-ta="viewTimesheet"
                  @updated-ta="fetchPayroll"
                />
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="p-3 bg-light mb-4">
                <h5 class="font-size-14 mb-0">Leave Information</h5>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <tr>
                        <th>Leave Type</th>
                        <th>BF</th>
                        <th>Accruals</th>
                        <th>Used</th>
                        <th>Balance</th>
                      </tr>
                      <tr>
                        <td>Annual</td>
                        <td>{{ annualBF }}</td>
                        <td>{{ annualAccrued }}</td>
                        <td>{{ Math.abs(annualUsed) }}</td>
                        <td>{{ annualBF + annualAccrued - annualUsed }}</td>
                      </tr>
                      <tr>
                        <td>Sick</td>
                        <td>{{ sickBF }}</td>
                        <td>{{ sickAccrued }}</td>
                        <td>{{ Math.abs(sickUsed) }}</td>
                        <td>{{ sickBF + sickAccrued - sickUsed }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showModal"
      title="Timesheet Entry"
      centered
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <p v-if="dateInfo" class="mb-4">
        Manage your Time Sheet Entry for
        <strong>{{ dateInfo.date.toDateString() }}</strong> or select another
        date to continue.
      </p>
      <div class="text-center">
        <a
          href="javascript: void(0);"
          class="dropdown-icon-item"
          @click="fillTSE(dateInfo)"
        >
          <i class="dripicons-clock" style="font-size: 2em"></i>
          <span>Manage Timesheet Entry</span>
        </a>
      </div>
    </b-modal>
    <b-modal
      v-model="showModalPH"
      title="Timesheet Entry"
      centered
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <p v-if="dateInfo" class="mb-4">
        <strong>{{ dateInfo.date.toDateString() }}</strong> is
        <strong class="text-capitalize"> {{ phName }} </strong>. Please select
        another date to fill.
      </p>
    </b-modal>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="3000"
      filename="Leave Application"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <div slot="pdf-content">
        <div class="text-center">
          <img
            style="width: 15%"
            src="data:image/png;base64,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"
            class="mt-3 mb-3"
          />
          <h4 class="mb-5">Employee Timesheet</h4>
        </div>
        <div class="card mb-3">
          <div class="card-body">
            <div class="p-3 bg-light mb-4">
              <h5 class="font-size-14 mb-0">
                International Rescue Committee - Overseas Staff
              </h5>
            </div>
            <div class="d-flex justify-content-between">
              <p>Payroll Reporting Period</p>
              <p class="font-weight-bolder">
                <span
                  >{{ new Date(pymFullDate).getMonth() | getMonth }}
                  {{ new Date(pymFullDate).getFullYear() }}</span
                >
              </p>
            </div>
            <div class="d-flex justify-content-between">
              <p>Name</p>
              <p>
                {{ getUser.user_name }}
              </p>
            </div>
            <div class="d-flex justify-content-between">
              <p>T7 Code</p>
              <p>{{ getEmployee.emp_unique_id }}</p>
            </div>
            <div class="d-flex justify-content-between">
              <p>Location (T6)</p>
              <p>{{ location }}</p>
            </div>
            <div class="d-flex justify-content-between">
              <p>Site Code (T3)</p>
              <p>{{ getEmployee.sector.d_t3_code }}</p>
            </div>
            <div class="d-flex justify-content-between">
              <p>Nationality</p>
              <p>Non-US</p>
            </div>
          </div>
        </div>
        <table class="table table-bordered mb-5">
          <thead>
            <tr>
              <th>#</th>
              <th>Day</th>
              <th>Start</th>
              <th>End</th>
              <th>Break</th>
              <th>Duration</th>
              <th>Attendance</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="table-light"
              v-for="(ts, index) in this.timesheet"
              :key="index"
            >
              <th scope="row">{{ index + 1 }}</th>
              <td>
                {{
                  new Date(
                    `${ts.ts_month}-${ts.ts_day}-${ts.ts_year}`
                  ).toDateString()
                }}
              </td>
              <td>
                <span v-if="ts.ts_is_present === 1">
                  {{ tConvert(ts.ts_start) }}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="ts.ts_is_present === 1">
                  {{ tConvert(ts.ts_end) }}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <span
                  v-if="
                    ts.ts_is_present === 1 &&
                    new Date(
                      `${ts.ts_month}-${ts.ts_day}-${ts.ts_year}`
                    ).getDay() !== 5
                  "
                >
                  30 mins
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="ts.ts_is_present === 1">
                  {{ ts.ts_duration }} hrs
                </span>
                <span v-else>-</span>
              </td>
              <td style="width: 10%">
                <small class="text-success" v-if="ts.ts_is_present === 1">
                  PRESENT
                </small>
                <small class="text-primary" v-else-if="ts.ts_is_present === 2">
                  <span v-if="ts.holiday"> {{ ts.holiday }} </span>
                  <span v-else> P. HOLIDAY </span>
                </small>
                <small class="text-warning" v-else-if="ts.ts_is_present === 3">
                  WEEKEND
                </small>
                <small
                  class="text-info text-uppercase"
                  v-else-if="ts.ts_is_present === 4"
                >
                  {{ ts.leaveType }}
                </small>
                <small class="text-danger" v-else>ABSENT</small>
              </td>
            </tr>
            <tr class="m-0 table-light">
              <th></th>
              <th>Total Duration</th>
              <th></th>
              <th></th>
              <th></th>
              <th>{{ totalDurationHrs }} hrs {{ totalDurationMins }} mins</th>
              <th></th>
            </tr>
          </tbody>
        </table>
        <div class="p-3 bg-light mb-4">
          <h5 class="font-size-14 mb-0">Time Allocation</h5>
        </div>
        <div v-if="status" class="mb-5">
          <b-row>
            <b-col lg="6">
              <p v-for="(charge, index) in breakdown" :key="index">
                <span class="mr-4"> Grant Code: {{ charge.ta_tcode }} </span>
                <span>Percentage Charge: {{ charge.ta_charge }}%</span>
              </p>
            </b-col>
            <b-col lg="6">
              <p v-for="(charge, index) in breakdown" :key="index">
                <span class="mr-4"> Match Code: {{ charge.ta_t0_code }} </span>
                <span>
                  Percentage Charge:
                  {{ parseInt(charge.ta_t0_percent) }}%
                </span>
              </p>
            </b-col>
          </b-row>
        </div>
        <div class="p-3 bg-light mb-4">
          <h5 class="font-size-14 mb-0">Authorization Log</h5>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Officer</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="table-light"
                    v-for="(off, ind) in this.log"
                    :key="ind"
                  >
                    <th scope="row">{{ ind + 1 }}</th>
                    <td v-if="off.officers">
                      {{
                        off.officers.emp_first_name
                          ? off.officers.emp_first_name
                          : ""
                      }}
                      {{
                        off.officers.emp_last_name
                          ? off.officers.emp_last_name
                          : ""
                      }}
                    </td>
                    <td>
                      <small v-if="off.auth_status === 1" class="text-success">
                        Approved
                      </small>
                      <small
                        v-else-if="off.auth_status === 2"
                        class="text-danger"
                      >
                        Discarded
                      </small>
                      <small v-else class="text-warning"> Pending </small>
                    </td>
                    <td>{{ off.auth_comment }}</td>
                    <td>
                      {{ new Date(off.updatedAt).toDateString() }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </VueHtml2pdf>
  </Layout>
</template>
